import React from 'react'

const SearchIcon = ({ ...rest }) => {
    return (
        <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="106" height="106" viewBox="0 0 106 106">
            <g id="Group_22693" data-name="Group 22693" transform="translate(-2291 16024)">
                <circle id="Ellipse_521" data-name="Ellipse 521" cx="53" cy="53" r="53" transform="translate(2291 -16024)" fill="#e8ebfe" />
                <g id="Group_22692" data-name="Group 22692" transform="translate(2320.643 -15994.356)">
                    <path id="Path_5112" data-name="Path 5112" d="M521.191,67.546a23.357,23.357,0,1,0-23.358-23.357A23.356,23.356,0,0,0,521.191,67.546Z" transform="translate(-497.833 -20.833)" fill="none" stroke="#604FF8" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" />
                    <path id="Path_5113" data-name="Path 5113" d="M518.717,41.716l-3.384-3.383" transform="translate(-472.156 3.986)" fill="none" stroke="#604FF8" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" />
                </g>
            </g>
        </svg>
    )
}

export default SearchIcon